import { IApplicationState } from '../../types/redux';

export function getSearchText(state: IApplicationState) {
  const { tab } = state;

  return state[tab].filters.searchText || '';
}
